/**
 * @generated SignedSource<<fb53fe55b742e22f4107254b5f91d769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedBreadcrumbs_item$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly isLinkable: boolean | null;
    readonly path: string | null;
    readonly text: string | null;
  }> | null;
  readonly " $fragmentType": "PdpRespSharedBreadcrumbs_item";
};
export type PdpRespSharedBreadcrumbs_item$key = {
  readonly " $data"?: PdpRespSharedBreadcrumbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedBreadcrumbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedBreadcrumbs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "231852762247c1fb272ee76a2093b078";

export default node;
